import { createSection } from "./createSection";

export const Section = createSection({});
